<template>
  <div :class="iconClass" :style="{ width: size + 'px', height: size + 'px', marginRight: '0.3rem' }">
    <slot>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4.16667 2.08073C4.16667 1.85061 4.35321 1.66406 4.58333 1.66406H14.4675C14.6976 1.66406 14.8842 1.85061 14.8842 2.08073V2.63876C14.8842 2.86888 14.6976 3.05543 14.4675 3.05543H5.94575C5.71563 3.05543 5.52908 3.24198 5.52908 3.4721V15.5263C5.52908 15.7564 5.34253 15.943 5.11242 15.943H4.58333C4.35321 15.943 4.16667 15.7564 4.16667 15.5263V2.08073ZM6.54728 4.45896C6.54728 4.22884 6.73383 4.04229 6.96395 4.04229H15.4167C15.6468 4.04229 15.8333 4.22884 15.8333 4.45896V13.1315C15.8333 13.361 15.6478 13.5473 15.4183 13.5482L11.7259 13.5631C11.4964 13.564 11.3109 13.7503 11.3109 13.9797V17.9141C11.3109 18.1442 11.1243 18.3307 10.8942 18.3307H6.96394C6.73383 18.3307 6.54728 18.1442 6.54728 17.9141V4.45896ZM12.5012 15.1717C12.5012 14.9416 12.6877 14.755 12.9179 14.755H14.7734C15.1429 14.755 15.3296 15.2003 15.0705 15.4638L13.215 17.3512C12.9535 17.6171 12.5012 17.432 12.5012 17.0591V15.1717Z"
          fill="currentColor"
        />
      </svg>
    </slot>
  </div>
</template>

<script>
  export default {
    name: 'IconLead',
    props: {
      iconClass: {
        type: String,
        default: '',
      },

      size: {
        type: [Number, String],
        default: '',
      },
    },
  };
</script>

<style scoped>
  /* You can add any additional styles here */
</style>
